<template>
    <select-input
        :items="brandsCollection.data.value"
        value-key-name="id"
        label-key-name="name"
        v-bind="$attrs"
    >
        <template #placeholder>
            <span v-text="t(`placeholder`)" />
        </template>
    </select-input>
</template>

<script lang="ts" setup>
    import { SelectInput } from '@keyvue/one-ui';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { Brand } from '@keyvue/one-api-client';
    import { onMounted } from 'vue';
    import { useI18n } from 'vue-i18n';
    import messages from './BrandSelectInput.messages.json';

    const { t } = useI18n({ messages });
    const { getLazyResourceCollection } = useClient();

    const brandsCollection = getLazyResourceCollection(Brand);

    onMounted(async () => {
        await brandsCollection.load();
    });
</script>
